import React from "react";
import Cookies from 'js-cookie';
import { groupBy, tabs } from "../utils";
import { useLocation } from "react-router-dom";
import ViewComponent from "../components/ViewComponent";
import { editFormPost, getFormData, addFormPost } from "../services/Form";
import Components from "../services/Components";
import Loader from "../components/Loader";
import { useHistory, useParams } from "react-router-dom";
import customSortFunction from "../utils/arrays";
import MyMarker from "./ViewMarker";
import GoogleMapReact from "google-map-react";
function ViewProperty(props) {

  const location = useLocation();
  const history = useHistory();
  const [data, setData] = React.useState(null);
  const [object, setObject] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [submit, setSubmit] = React.useState(false);
  const [tabs, setTabs] = React.useState([]);
  const [show, setShow] = React.useState(true);
  const [active, setActive] = React.useState(tabs[0]);
  const [IsStyle, setstyle1SF] = React.useState("ShowContent");
  const [tabsImage, setTabsImage] = React.useState({});
  const [isdownload, setisdownload] = React.useState("");
  const [formId, setFormId] = React.useState(0);
  const [response, setResponse] = React.useState(null);
  const [coords, setCoords] = React.useState({ lng: 0, lat: 0, });
  let currentactive = "";
  let form_id = 0;

  form_id = atob(useParams().id);

  const _array = form_id.split("_");
  form_id = _array[1];
  currentactive = _array[0];

  const defaultMapOptions = { fullscreenControl: false, scrollwheel: false, };
  React.useEffect(() => {
    window.scrollTo(0, 0);
    getFormData(form_id).then(async (res) => {

      setResponse(res);
      setFormId(res.FormId);
      let resp = res.FormValues.sort((a, b) => a.ParamOrder - b.ParamOrder);
      setData(resp.map((item) => ({ ...item, Value: item.value.replace(/['"]+/g, "") })));
      let obj = groupBy(resp, "Phase");
      setObject(obj);
      Cookies.set('AddAddressString', resp[2].value.replace(/['"]+/g, ""));
      setCoords({ lat: Number(resp[0].value.replace(/['"]+/g, "")), lng: Number(resp[1].value.replace(/['"]+/g, "")) });
      let structures = {};
      res.StructureTypes.map((str, index) => {
        let newArr = [];
        str.Calculations.map((item) => {
          newArr.push({
            Phase: item.Phase,
            ParameterTypeId: item.ParameterTypeId,
            ParameterId: item.ParameterId,
            ParameterName: item.ParameterName,
            value: item.value.replace(/['"]+/g, ""),
            ischecked: item.ischecked,
            structureType: str.StructureType,
            IsManual: item.IsManual,
            isComplete: item.isComplete,
            perhomevalue: item.perhomevalue,
            perprojectvalue: item.perprojectvalue,
          });
        });
        structures[str.StructureType] = groupBy(newArr, "Phase");
      });
      setTabs(structures);
      res.FormValues.map((item) => {

        if (item.ParameterId === 6) {
          if (item.value.replace(/['"]+/g, "") === "NR3" || item.value.replace(/['"]+/g, "") === "NR2" || item.value.replace(/['"]+/g, "") === "NR3" || item.value.replace(/['"]+/g, "") === "RSL") {
            setActive(Object.keys(structures)[0]);
          }
          if (item.value.replace(/['"]+/g, "") === "LR1" || item.value.replace(/['"]+/g, "") === "LR2" || item.value.replace(/['"]+/g, "") === "LR3") {
            setActive(Object.keys(structures)[1]);
          }
          if (item.value.replace(/['"]+/g, "") === "NC1-30" || item.value.replace(/['"]+/g, "") === "NC1-40" || item.value.replace(/['"]+/g, "") === "NC1-55" || item.value.replace(/['"]+/g, "") === "NC2-30" || item.value.replace(/['"]+/g, "") === "NC2-40" || item.value.replace(/['"]+/g, "") === "NC2-55") {
            setActive(Object.keys(structures)[1]);
          }
          if (item.value.replace(/['"]+/g, "") === "MR") {
            setActive(Object.keys(structures)[3]);
          }
        }
        setActive(currentactive);
      });
      setSubmit(true);
    });
  }, []);


  const printDocument = (e) => {
    //setLoading(true);
    setisdownload("marginTop24");
    setstyle1SF("HideContent");

    setShow(false);

    setTimeout(() => {
      console.log("here")
      window.print();
    }, 1000);

    setTimeout(() => {
      setShow(true);
      setstyle1SF("ShowContent");
      setisdownload("");
    }, 1000);
  };
  return (
    <>
      {/* <div className="modal-overlay hide-pc">
<div className="card" style={{marginTop:"50%"}}>
            <div className="card-body text-center" >
                <h3 className="card-title"><i className='fa fa-warning mr-2'></i><br></br>Alert !</h3>
                <p className="card-text">At this moment, the application is exclusively compatible with the
desktop mode. However, please rest assured that our team is diligently working towards
enhancing its compatibility with mobile interfaces. We understand the inconvenience
caused and greatly appreciate your patience and understanding during this process.<br></br>
Thank you.</p>
                
            </div>
        </div>
</div> */}
      <div class="main_dashboard" style={{ backgroundColor: "rgb(247, 250, 253)" }}>

        <div id="content-wrapper" class="content-wrapper  d-flex flex-column full-window-div" >


          <div class={IsStyle} style={{ marginLeft: "0px" }}>
            {show && (


              <nav class="row navbar navbar-expand navbar-light topbar fixed-top bg-blue" style={{ marginLeft: "0px", padding: "0px" }}>
                <div class="col-md-1" style={{ padding: "0px", maxWidth: "80px" }}>
                  <a class="">
                    <div class="sidebar-brand-text" ><img src="/assets/img/LB-Icon-White.svg" alt=""></img></div>
                  </a>
                </div>
                <div class="col-md-11">
                  <div class="row" style={{ alignItems: "center" }}>
                    <div class="col-md-10 col-12">  <h4 style={{ color: "White", float: "right" }}>Create your LandBridge account

                    </h4></div>
                    <div class="col-md-2 col">
                      <a href="https://www.landbridge.tech/"> <button class="btn btn-primary  returnDashboard" type="button" style={{ marginLeft: "4%", width: "100%", float: "right" }}>
                        Get Started
                      </button></a>
                    </div>
                  </div>

                </div>


              </nav>)}


            <div class="Bottom " >
              <img src="../assets/img/Topo.png" alt="LB-Icon-White.svg"></img>
            </div>

            <div  >
              {!(object && data) ? <Loader /> :
                <div class=" page-content-section">
                  <div class="container-fluid heading-propaty heading-propaty1" style={{ marginTop: "-4%" }}>
                    <div class="row" style={{ width: "100%" }}>
                      <div class="col-md-12">
                        <h3 class="ViewHeader">{Cookies.get('AddAddressString') || "123"}</h3>


                      </div>  </div></div>
                  <div class="container-fluid row">

                    <div class="col-md-7" style={{ height: "390px" }}>
                      <GoogleMapReact
                        bootstrapURLKeys={{ key: "" }}
                        center={[coords.lat, coords.lng]}
                        defaultZoom={11}
                        yesIWantToUseGoogleMapApiInternals
                        options={defaultMapOptions}
                        //onGoogleApiLoaded={myFunc}
                        mapType={"hybrid"}
                      >
                        <MyMarker key={1} lat={coords.lat} lng={coords.lng} text={""} tooltip={""} />
                      </GoogleMapReact>
                    </div>
                    <div class="col-md-5 rounded" style={{ backgroundColor: "rgb(35, 100, 176)", marginTop: "-9%" }}>


                      <div class="bg_content1 mt-5 mb-5" >

                        <h3 style={{ color: "white" }}> <img src="../assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg" style={{ width: "7%" }}></img>  <b>LandBridge Report</b></h3>

                        {submit && (
                          <form class="">
                            {customSortFunction(Object.keys(tabs["Single Family"])).map((item, index) => {

                              if (item == "Proforma Breakdown") {
                                return (
                                  <>


                                    <div>

                                      <ViewComponent
                                        key={JSON.stringify(tabsImage) + index.toString()}
                                        name={item}
                                        object={tabs[active]}
                                        index={index}
                                        useVals={true}
                                        setTabsImage={setTabsImage}

                                        active={currentactive}
                                        setObject2={(data) => {
                                          console.log("main", data);
                                          let t = tabs;
                                          tabs[currentactive][data.Phase] = tabs[
                                            currentactive
                                          ][data.Phase].map((item) =>
                                            item.ParameterId === data.ParameterId
                                              ? data
                                              : item
                                          );
                                          setTabs(t)
                                        }}
                                        ISReport="9"
                                      />
                                      <div class="row" style={{ padding: "0% 10% 0% 10%" }}>
                                        {show && (<>
                                          <div class="col-md-6 mb-2">
                                            <button class="btn btn-primary  PrintButton" type="button" onClick={printDocument} style={{ width: "100%" }}>
                                              {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" style={{ color: "black" }}></span>}
                                              Download
                                            </button></div> <div class="col-md-6 mb-2">
                                            <button class="btn btn-primary  PrintButton" onClick={printDocument} type="button" style={{ width: "100%" }}>
                                              Print
                                            </button></div> </>)}</div>
                                    </div>
                                  </>
                                );
                              }
                            })}

                          </form>
                        )}

                      </div>
                    </div>



                  </div>
                  <br />
                  <div class="container-fluid mb-2 bg-white rounded" style={{ padding: "3%" }} >


                    <div class="row">
                      <div class="col-md-3  align-items-center ">
                        <h5 ><b>Property Details</b></h5>

                        <div class="row">
                          {object &&
                            object["Site Information"].map((item) => (

                              <>

                                <div class="col-md-4 col-6" style={{ padding: "0%" }}>


                                  <div class="propertdetails"> <b>{item.ParameterName}:</b> </div>

                                </div>
                                <div class="col-md-8 col-6">

                                  <input type="text" id={"param" + item.ParameterId} value={item.value.replace(/['"]+/g, "")} style={{ display: "none" }}></input>
                                  <div class="propertdetails"> {item.value.replace(/['"]+/g, "")} </div>
                                </div>
                              </>
                            ))}
                        </div>
                      </div>
                      <div class="col-md-9  align-items-center ">
                        <div class="row">
                          <div class="col-md-12  align-items-center " >

                            <h5><b>Geographical Analysis</b></h5>
                            <div class="row">
                              {object &&
                                object["Geographical Analysis"].map((item) => (

                                  <>
                                    <div class="col-md-3 col-6" style={{ padding: "0%" }}>


                                      <div class="propertdetails" >   <b>{item.ParameterName}:</b> </div>
                                      <input type="text" id={"param" + item.ParameterId} value={item.value.replace(/['"]+/g, "")} style={{ display: "none" }}></input>


                                    </div>
                                    <div class="col-md-3 col-6">


                                      <div class="propertdetails">  {item.value.replace(/['"]+/g, "")} </div>
                                    </div>
                                  </>
                                ))} </div>
                          </div>

                          <div class="col-md-12    align-items-center ">
                            <br />
                            <h5 ><b>Utilities/Extras</b></h5>
                            <div class="row">
                              <div class="col-md-6" style={{ padding: "0%" }}>
                                <div class="row">
                                  {object &&
                                    object["Utilities/Extras"].map((item) => (


                                      (item.ParameterId == 20 || item.ParameterId == 21 || item.ParameterId == 22 || item.ParameterId == 23 || item.ParameterId == 24 || item.ParameterId == 25) ? (
                                        <>
                                          <div class="col-md-4 col-6" style={{ padding: "0%" }}>


                                            <div class="propertdetails" >   <b>{item.ParameterName}:</b></div>


                                          </div>
                                          <div class="col-md-2 col-6">

                                            <input type="text" id={"param" + item.ParameterId} value={item.value.replace(/['"]+/g, "")} style={{ display: "none" }}></input>

                                            <div class="propertdetails"> {item.value.replace(/['"]+/g, "")} </div>
                                          </div>
                                        </>
                                      ) : (<></>)



                                    ))}
                                </div>
                              </div>
                              <div class="col-md-6" style={{ padding: "0%" }}>
                                <div class="row">
                                  {object &&
                                    object["Utilities/Extras"].map((item) => (


                                      (item.ParameterId == 83 || item.ParameterId == 84 || item.ParameterId == 26 || item.ParameterId == 27) ? (
                                        <>
                                          <div class="col-md-4 col-6" style={{ padding: "0%" }}>


                                            <div class="propertdetails" >   <b>{item.ParameterName}:</b></div>


                                          </div>
                                          <div class="col-md-2 col-6">

                                            <input type="text" id={"param" + item.ParameterId} value={item.value.replace(/['"]+/g, "")} style={{ display: "none" }}></input>

                                            <div class="propertdetails"> {item.value.replace(/['"]+/g, "")} </div>
                                          </div>
                                        </>
                                      ) : (<></>)



                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>


                  <div class="container-fluid mb-4 bg-white rounded" style={{ padding: "3%" }}>

                    <div class="row  justify-content-center align-items-center ">
                      {object &&
                        object["Property Images"].map((item) => (

                          <div class=" col-md-4  justify-content-between  align-items-center ">

                            <h5 >
                              <b> {item.ParameterName}</b>
                              <br /> <br />


                              <img src={item.value.replace(/['"]+/g, "")} alt="LB-Icon-White.svg" style={{ width: "100%" }}></img>
                            </h5> </div>

                        ))}
                    </div> </div>
                  {!show && (
                    <nav class="navbar-expand navbar-light topbar" id="pdfTableaaaaa" style={{ marginTop: "3%" }}>

                      <div style={{ backgroundColor: "#2967b2", textAlign: "center" }}>
                        <img src="../assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg" style={{ paddingBottom: "20px", marginTop: "4%", width: "60px" }}></img>
                        <p style={{ color: "White", paddingBottom: "4%" }}>© {new Date().getFullYear()} LandBridge Technologies.  All rights reserved.</p>
                      </div>

                    </nav>)}






                  {submit && (
                    <form class="">
                      <ul class="nav mytab nav-pills justify-content-center" id="pills-tab" role="tablist" style={{ marginTop: "-1%" }} >

                        {Object.keys(tabs).map((name, item) => {
                          let style = "nav-link ";
                          let issingleFamily = false;
                          let isNotsingleFamily = false;
                          let isNotsingleFamilyCond = false;
                          let isAptCond = false;
                          let svgPath = ""; let svgPath1 = ""; let svgPath2 = ""; let svgPath3 = ""; let svgPath4 = "";
                          let svgPath5 = ""; let svgPath6 = ""; let svgPath7 = ""; let svgPath8 = "";
                          let viewBox = "0 1.117 17 14.767";
                          if (currentactive === name) style += "active";

                          if (name == "Single Family") {

                            svgPath = "m16.667 7.379-4.16-3.096V.723A.725.725 0 0 0 11.784 0a.726.726 0 0 0-.724.723v2.484L8.89 1.59a.706.706 0 0 0-.832 0L.281 7.38c-.325.217-.361.65-.144.976.217.326.65.362.976.145l.724-.535v8.312c0 .397.325.723.723.723h11.864c.398 0 .723-.326.76-.723V8.016l.65.484c.145.109.29.145.435.145.217 0 .434-.073.542-.29.217-.289.181-.76-.144-.976Zm-9.115 8.21v-3.617h1.88v3.617h-1.88Zm6.185 0h-2.858v-4.34a.726.726 0 0 0-.723-.723H6.864a.726.726 0 0 0-.723.723v4.34H3.247V8.174h10.49v7.415ZM3.507 6.728l4.985-3.69 2.79 2.076c.045.043.095.08.15.11l2.02 1.504H3.508Z"
                          }
                          else if (name == "Townhome") {
                            viewBox = "0";
                            svgPath1 = "M13.357 26.493h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                            svgPath2 = "M13.357 17.441h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                            svgPath3 = "M37.09 26.493h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                            svgPath4 = "M37.09 17.441h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                            svgPath = "M51.773 49.785v-39.63c0-.993-.552-1.765-1.436-2.097L26.604.11c-.663-.22-1.435-.11-1.987.332-.552.441-.883 1.103-.883 1.766v4.89L2.87.11C2.208-.11 1.435 0 .883.442.331.883 0 1.545 0 2.208v47.467c0 1.214.994 2.208 2.208 2.208h47.467c1.214 0 2.208-.994 2.098-2.098ZM4.305 5.188l19.429 6.403v35.987h-7.507V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143H4.305V5.188Zm43.273 42.39H40.07V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143h-7.507V5.188l19.429 6.403v35.987Z"
                          }
                          else if (name == "Rowhouse") {
                            svgPath = "M16.385 14.653h-.47V1.777a.672.672 0 0 0-.326-.543.621.621 0 0 0-.614 0L11.9 3.051v-1.31a.672.672 0 0 0-.325-.543.621.621 0 0 0-.615 0L7.704 3.146V1.74a.597.597 0 0 0-.325-.543c-.217-.108-.47-.108-.651.036l-5.354 3.87a.69.69 0 0 0-.253.507v9.042H.615a.634.634 0 0 0-.615.615c0 .326.29.615.615.615H16.385c.326 0 .615-.29.615-.615a.634.634 0 0 0-.615-.615Zm-5.75-11.827v11.827h-2.93V4.563l2.93-1.737ZM2.35 5.9l4.123-2.966v11.72H5.028v-2.641a.634.634 0 0 0-.615-.615.634.634 0 0 0-.615.615v2.64H2.35V5.9Zm9.549 8.753V4.463l2.749-1.637v11.827H11.9Z"
                          }
                          else if (name == "Cottage") {
                            svgPath = "M8.879.126c-.253-.144-.541-.144-.758 0C2.887 3.375 0 7.706 0 12.29v3.97c0 .397.325.722.722.722h15.52a.779.779 0 0 0 .758-.686V12.29C17 7.67 14.113 3.375 8.879.126ZM6.786 15.574v-4.511h3.356v4.511H6.786Zm8.77 0h-3.97v-5.197a.724.724 0 0 0-.722-.722H6.1a.724.724 0 0 0-.722.722v5.197h-3.97V12.29c0-4.007 2.526-7.796 7.074-10.72 4.584 2.96 7.074 6.75 7.074 10.72v3.284Z"
                          }
                          else if (name == "Condo") {
                            viewBox = "0";
                            svgPath1 = "M32.435 43.024a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.23 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                            svgPath2 = "M19.952 43.024c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.229 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                            svgPath3 = "M32.435 29.537a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.23 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                            svgPath4 = "M19.952 29.537c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.229 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                            svgPath = "M50.269 47.928h-2.787V17.504l1.784.775c.334.112.557.223.891.223.892 0 1.672-.557 2.007-1.337.446-1.115 0-2.452-1.115-2.898L40.683 9.774V2.229A2.236 2.236 0 0 0 38.454 0a2.236 2.236 0 0 0-2.23 2.23V7.84l-14.49-6.28c-.668-.224-1.448-.224-2.117.222L1.003 14.49C0 15.159-.223 16.496.446 17.5c.669 1.002 2.006 1.225 3.01.557l1.56-1.067v30.938H2.229A2.236 2.236 0 0 0 0 50.158a2.236 2.236 0 0 0 2.23 2.229h47.927c1.226 0 2.341-1.004 2.341-2.23a2.236 2.236 0 0 0-2.23-2.229ZM9.215 14.12l11.851-8.101 21.958 9.547v32.362H9.474v-32.77c0-.374-.094-.728-.259-1.038Z"
                          }
                          else if (name == "Apartment") {

                            svgPath1 = "M2.894 12.551a.726.726 0 0 0-.724.723v.217c0 .398.326.724.724.724.361 0 .687-.29.723-.724v-.217a.726.726 0 0 0-.723-.723Z"

                            svgPath2 = "M2.894 9.006a.726.726 0 0 0-.724.724v.217c0 .398.326.723.724.723.361 0 .687-.325.723-.723V9.73a.726.726 0 0 0-.723-.724Z"

                            svgPath3 = "M14.106 14.215c.398 0 .724-.29.724-.724v-.217a.726.726 0 0 0-.724-.723.726.726 0 0 0-.723.723v.217c0 .398.326.724.723.724Z"

                            svgPath4 = "M14.106 10.67a.726.726 0 0 0 .724-.723V9.73a.726.726 0 0 0-.724-.724.726.726 0 0 0-.723.724v.217c0 .398.326.723.723.723Z"

                            svgPath5 = "M9.549 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                            svgPath6 = "M7.451 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                            svgPath7 = "M9.549 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"
                            svgPath8 = "M7.451 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"

                            svgPath = "M16.277 5.787h-3.581V.723A.726.726 0 0 0 11.972 0H5.064a.726.726 0 0 0-.724.723v5.064H.723A.726.726 0 0 0 0 6.511v9.766c0 .397.326.723.723.723h15.553a.726.726 0 0 0 .724-.723V6.51a.725.725 0 0 0-.723-.724Zm-5.064-4.376V15.589h-1.99v-4.412a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v4.412h-1.99V6.511a.717.717 0 0 0-.036-.225V1.41h5.462ZM1.41 7.234h2.93v8.355H1.41V7.234Zm14.178 8.355h-2.893V7.234h2.893v8.355Z"
                          }
                          data.forEach(param => {
                            if (param.ParameterId === 6) {
                              if (param.Value === "NR3" || param.Value === "NR2" || param.Value === "NR3" || param.Value === "RSL") {

                                issingleFamily = true;
                                return;
                              }
                              if (param.Value === "LR1" || param.Value === "LR2" || param.Value === "LR3") {

                                isNotsingleFamily = true;
                                return;
                              }
                              if (param.Value === "NC1-30" || param.Value === "NC1-40" || param.Value === "NC1-55" || param.Value === "NC2-30" || param.Value === "NC2-40" || param.Value === "NC2-55") {

                                isNotsingleFamilyCond = true;
                                return;
                              }
                              if (param.Value === "MR") {

                                isAptCond = true;
                                return;
                              }
                            }
                          }
                          );
                          if (issingleFamily === true && name === "Single Family" && currentactive == name) {

                            return (
                              <li class="nav-item" role="presentation" onClick={() => setActive(currentactive)}>
                                <a class={style} id="pills-home-tab" data-toggle="pill" href="#pills-home"
                                  role="tab" aria-controls="pills-home" aria-selected="true">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="52.338" height="52.498" viewBox={viewBox}>
                                    <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                      <path d={svgPath1} fill="#1d3d70" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath2} fill="#1d3d70" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath3} fill="#1d3d70" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath4} fill="#1d3d70" fill-rule="evenodd" data-name="Path 549" />
                                      <path d={svgPath5} fill="#1d3d70" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath6} fill="#1d3d70" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath7} fill="#1d3d70" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath8} fill="#1d3d70" fill-rule="evenodd" data-name="Path 549" />

                                      <path d={svgPath} fill="#f7f7f7" fill-rule="evenodd" data-name="Path 548" />
                                    </g></svg>
                                </a>
                              </li>

                            );

                          }
                          if (isNotsingleFamily === true && name !== "Single Family" && currentactive == name) {
                            //setActive("Townhome");
                            return (
                              <li class="nav-item" role="presentation" onClick={() => setActive(currentactive)}>
                                <a class={style} id="pills-profile-tab" data-toggle="pill" href="#pills-profile"
                                  role="tab" aria-controls="pills-profile" aria-selected="false">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="52.427" height="52.53" viewBox={viewBox}>

                                    <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                      <path d={svgPath1} fill="#1d3d70" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath2} fill="#1d3d70" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath3} fill="#1d3d70" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath4} fill="#1d3d70" fill-rule="evenodd" data-name="Path 549" />
                                      <path d={svgPath5} fill="#1d3d70" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath6} fill="#1d3d70" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath7} fill="#1d3d70" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath8} fill="#1d3d70" fill-rule="evenodd" data-name="Path 549" />

                                      <path d={svgPath} fill="#f7f7f7" fill-rule="evenodd" data-name="Path 548" />
                                    </g>
                                  </svg>
                                </a>
                              </li>
                            );

                          }
                          if (isNotsingleFamilyCond === true && (name !== "Single Family" && name !== "Cottage") && currentactive == name) {
                            //setActive("Townhome");
                            return (
                              <li class="nav-item" role="presentation">
                                <a class={style} id="pills-contact-tab" data-toggle="pill" href="#pills-contact"
                                  role="tab" aria-controls="pills-contact" aria-selected="false">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="52.498" height="52.387" viewBox={viewBox}>
                                    <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                      <path d={svgPath1} fill="#1d3d70" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath2} fill="#1d3d70" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath3} fill="#1d3d70" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath4} fill="#1d3d70" fill-rule="evenodd" data-name="Path 549" />
                                      <path d={svgPath5} fill="#1d3d70" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath6} fill="#1d3d70" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath7} fill="#1d3d70" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath8} fill="#1d3d70" fill-rule="evenodd" data-name="Path 549" />

                                      <path d={svgPath} fill="#f7f7f7" fill-rule="evenodd" data-name="Path 548" />
                                    </g></svg>
                                </a>
                              </li>

                            );

                          }
                          if (isAptCond === true && (name === "Apartment" || name === "Condo") && currentactive == name) {
                            //setActive("Cottage");
                            return (
                              <li class="nav-item" role="presentation">
                                <a class={style} id="pills-contact-tab" data-toggle="pill" href="#pills-contact"
                                  role="tab" aria-controls="pills-contact" aria-selected="false">

                                  <svg xmlns="http://www.w3.org/2000/svg" width="52.498" height="52.387" viewBox={viewBox}>
                                    <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                      <path d={svgPath1} fill="#1d3d70" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath2} fill="#1d3d70" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath3} fill="#1d3d70" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath4} fill="#1d3d70" fill-rule="evenodd" data-name="Path 549" />
                                      <path d={svgPath5} fill="#1d3d70" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath6} fill="#1d3d70" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath7} fill="#1d3d70" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath8} fill="#1d3d70" fill-rule="evenodd" data-name="Path 549" />

                                      <path d={svgPath} fill="#f7f7f7" fill-rule="evenodd" data-name="Path 548" />
                                    </g>
                                  </svg>
                                </a>
                              </li>
                            );

                          }
                          else {

                            return (
                              <button
                                type="button"
                                class={style}
                                style={{ display: "none" }}
                                onClick={() => setActive(currentactive)}
                              >
                                {currentactive}
                              </button>
                            );
                          }


                        }


                        )}
                      </ul>
                      <div class="tab-content">





                        {customSortFunction(Object.keys(tabs[currentactive])).map((item, index) => {
                          let viewBox = "0 1.117 17 14.767";
                          let style = "toptop  mt-5 text-center display mb-5";
                          let Footerstyle = "navbar-expand navbar-light topbar";
                          if (item == "Site Potential") { style = "toptop  mt-5 text-center mb-5"; }
                          let svgPath = ""; let svgPath1 = ""; let svgPath2 = ""; let svgPath3 = ""; let svgPath4 = "";
                          let svgPath5 = ""; let svgPath6 = ""; let svgPath7 = ""; let svgPath8 = "";
                          if (currentactive == "Single Family") {

                            svgPath = "m16.667 7.379-4.16-3.096V.723A.725.725 0 0 0 11.784 0a.726.726 0 0 0-.724.723v2.484L8.89 1.59a.706.706 0 0 0-.832 0L.281 7.38c-.325.217-.361.65-.144.976.217.326.65.362.976.145l.724-.535v8.312c0 .397.325.723.723.723h11.864c.398 0 .723-.326.76-.723V8.016l.65.484c.145.109.29.145.435.145.217 0 .434-.073.542-.29.217-.289.181-.76-.144-.976Zm-9.115 8.21v-3.617h1.88v3.617h-1.88Zm6.185 0h-2.858v-4.34a.726.726 0 0 0-.723-.723H6.864a.726.726 0 0 0-.723.723v4.34H3.247V8.174h10.49v7.415ZM3.507 6.728l4.985-3.69 2.79 2.076c.045.043.095.08.15.11l2.02 1.504H3.508Z"
                          }
                          else if (currentactive == "Townhome") {
                            viewBox = "";
                            svgPath1 = "M13.357 26.493h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                            svgPath2 = "M13.357 17.441h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                            svgPath3 = "M37.09 26.493h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                            svgPath4 = "M37.09 17.441h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                            svgPath = "M51.773 49.785v-39.63c0-.993-.552-1.765-1.436-2.097L26.604.11c-.663-.22-1.435-.11-1.987.332-.552.441-.883 1.103-.883 1.766v4.89L2.87.11C2.208-.11 1.435 0 .883.442.331.883 0 1.545 0 2.208v47.467c0 1.214.994 2.208 2.208 2.208h47.467c1.214 0 2.208-.994 2.098-2.098ZM4.305 5.188l19.429 6.403v35.987h-7.507V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143H4.305V5.188Zm43.273 42.39H40.07V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143h-7.507V5.188l19.429 6.403v35.987Z"
                          }
                          else if (currentactive == "Rowhouse") {
                            svgPath = "M16.385 14.653h-.47V1.777a.672.672 0 0 0-.326-.543.621.621 0 0 0-.614 0L11.9 3.051v-1.31a.672.672 0 0 0-.325-.543.621.621 0 0 0-.615 0L7.704 3.146V1.74a.597.597 0 0 0-.325-.543c-.217-.108-.47-.108-.651.036l-5.354 3.87a.69.69 0 0 0-.253.507v9.042H.615a.634.634 0 0 0-.615.615c0 .326.29.615.615.615H16.385c.326 0 .615-.29.615-.615a.634.634 0 0 0-.615-.615Zm-5.75-11.827v11.827h-2.93V4.563l2.93-1.737ZM2.35 5.9l4.123-2.966v11.72H5.028v-2.641a.634.634 0 0 0-.615-.615.634.634 0 0 0-.615.615v2.64H2.35V5.9Zm9.549 8.753V4.463l2.749-1.637v11.827H11.9Z"
                          }
                          else if (currentactive == "Cottage") {
                            svgPath = "M8.879.126c-.253-.144-.541-.144-.758 0C2.887 3.375 0 7.706 0 12.29v3.97c0 .397.325.722.722.722h15.52a.779.779 0 0 0 .758-.686V12.29C17 7.67 14.113 3.375 8.879.126ZM6.786 15.574v-4.511h3.356v4.511H6.786Zm8.77 0h-3.97v-5.197a.724.724 0 0 0-.722-.722H6.1a.724.724 0 0 0-.722.722v5.197h-3.97V12.29c0-4.007 2.526-7.796 7.074-10.72 4.584 2.96 7.074 6.75 7.074 10.72v3.284Z"
                          }
                          else if (currentactive == "Condo") {
                            viewBox = "";
                            svgPath1 = "M32.435 43.024a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.23 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                            svgPath2 = "M19.952 43.024c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.229 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                            svgPath3 = "M32.435 29.537a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.23 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                            svgPath4 = "M19.952 29.537c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.229 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                            svgPath = "M50.269 47.928h-2.787V17.504l1.784.775c.334.112.557.223.891.223.892 0 1.672-.557 2.007-1.337.446-1.115 0-2.452-1.115-2.898L40.683 9.774V2.229A2.236 2.236 0 0 0 38.454 0a2.236 2.236 0 0 0-2.23 2.23V7.84l-14.49-6.28c-.668-.224-1.448-.224-2.117.222L1.003 14.49C0 15.159-.223 16.496.446 17.5c.669 1.002 2.006 1.225 3.01.557l1.56-1.067v30.938H2.229A2.236 2.236 0 0 0 0 50.158a2.236 2.236 0 0 0 2.23 2.229h47.927c1.226 0 2.341-1.004 2.341-2.23a2.236 2.236 0 0 0-2.23-2.229ZM9.215 14.12l11.851-8.101 21.958 9.547v32.362H9.474v-32.77c0-.374-.094-.728-.259-1.038Z"
                          }
                          else if (currentactive == "Apartment") {

                            svgPath1 = "M2.894 12.551a.726.726 0 0 0-.724.723v.217c0 .398.326.724.724.724.361 0 .687-.29.723-.724v-.217a.726.726 0 0 0-.723-.723Z"

                            svgPath2 = "M2.894 9.006a.726.726 0 0 0-.724.724v.217c0 .398.326.723.724.723.361 0 .687-.325.723-.723V9.73a.726.726 0 0 0-.723-.724Z"

                            svgPath3 = "M14.106 14.215c.398 0 .724-.29.724-.724v-.217a.726.726 0 0 0-.724-.723.726.726 0 0 0-.723.723v.217c0 .398.326.724.723.724Z"

                            svgPath4 = "M14.106 10.67a.726.726 0 0 0 .724-.723V9.73a.726.726 0 0 0-.724-.724.726.726 0 0 0-.723.724v.217c0 .398.326.723.723.723Z"

                            svgPath5 = "M9.549 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                            svgPath6 = "M7.451 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                            svgPath7 = "M9.549 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"
                            svgPath8 = "M7.451 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"

                            svgPath = "M16.277 5.787h-3.581V.723A.726.726 0 0 0 11.972 0H5.064a.726.726 0 0 0-.724.723v5.064H.723A.726.726 0 0 0 0 6.511v9.766c0 .397.326.723.723.723h15.553a.726.726 0 0 0 .724-.723V6.51a.725.725 0 0 0-.723-.724Zm-5.064-4.376V15.589h-1.99v-4.412a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v4.412h-1.99V6.511a.717.717 0 0 0-.036-.225V1.41h5.462ZM1.41 7.234h2.93v8.355H1.41V7.234Zm14.178 8.355h-2.893V7.234h2.893v8.355Z"
                          }

                          if (currentactive == "Single Family") {
                            if (item == "Land Analysis") {
                              Footerstyle = Footerstyle + " marginTop30";
                            }
                            if (item == "Building Cost Breakdown") {
                              Footerstyle = Footerstyle + " marginTop9";
                            }
                            if (item == "Financing") {
                              Footerstyle = Footerstyle + " marginTop41";
                            }
                            if (item == "Building Cost Breakdown") {
                              return (
                                <>

                                  <div class={style}>
                                    <h2 class="d-flex align-items-center justify-content-center" style={{ color: "#a0b3c6" }}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="52.498" height="52.387" viewBox={viewBox} style={{ marginRight: "3%" }}>
                                        <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                          <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                          <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                          <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                          <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                          <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                          <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                          <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                          <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                          <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                        </g>
                                      </svg>
                                      {currentactive} Evaluation
                                    </h2>

                                  </div>
                                  <div class="card custom-accordian view-custom-accordian mt-4" style={{ border: "0px !important" }}>

                                    <ViewComponent
                                      key={JSON.stringify(tabsImage) + index.toString()}
                                      name={item}
                                      object={tabs[currentactive]}
                                      index={index}
                                      useVals={true}
                                      setTabsImage={setTabsImage}

                                      active={currentactive}
                                      setObject2={(data) => {
                                        console.log("main", data);
                                        let t = tabs;
                                        tabs[currentactive][data.Phase] = tabs[
                                          currentactive
                                        ][data.Phase].map((item) =>
                                          item.ParameterId === data.ParameterId
                                            ? data
                                            : item
                                        );
                                        setTabs(t)
                                      }}

                                    />

                                  </div>


                                  {!show && (<>
                                    <br />
                                    <br />  <br />  <br />  <br />
                                    <h4 class="d-flex align-items-center justify-content-center" style={{ color: "#a0b3c6", marginTop: "2%" }}>
                                      {Cookies.get('AddAddressString') || "123"}
                                    </h4>
                                  </>)}
                                </>


                              );
                            }
                            else if (item == "Building Cost Breakdown" || item == "Land Analysis" || item == "Financing") {
                              return (
                                <>

                                  <div class={style}>
                                    <h2 class="d-flex align-items-center justify-content-center" style={{ color: "#a0b3c6" }}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="52.498" height="52.387" viewBox={viewBox} style={{ marginRight: "3%" }}>
                                        <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                          <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                          <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                          <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                          <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                          <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                          <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                          <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                          <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                          <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                        </g>
                                      </svg>
                                      {currentactive} Evaluation
                                    </h2>

                                  </div>
                                  <div class="card custom-accordian view-custom-accordian mt-4" style={{ border: "0px !important" }}>

                                    <ViewComponent
                                      key={JSON.stringify(tabsImage) + index.toString()}
                                      name={item}
                                      object={tabs[currentactive]}
                                      index={index}
                                      useVals={true}
                                      setTabsImage={setTabsImage}

                                      active={currentactive}
                                      setObject2={(data) => {
                                        console.log("main", data);
                                        let t = tabs;
                                        tabs[currentactive][data.Phase] = tabs[
                                          currentactive
                                        ][data.Phase].map((item) =>
                                          item.ParameterId === data.ParameterId
                                            ? data
                                            : item
                                        );
                                        setTabs(t)
                                      }}

                                    />

                                  </div>


                                  {!show && (<><nav class={Footerstyle} id="pdfTableaaaaa" >

                                    <div style={{ backgroundColor: "#2967b2", textAlign: "center" }}>
                                      <img src="../assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg" style={{ paddingBottom: "20px", marginTop: "4%", width: "60px" }}></img>
                                      <p style={{ color: "White", paddingBottom: "4%" }}>© {new Date().getFullYear()} LandBridge Technologies.  All rights reserved.</p>
                                    </div>

                                  </nav>
                                    <br />
                                    <br /> <br />
                                    <h4 class="d-flex align-items-center justify-content-center" style={{ color: "#a0b3c6" }}>
                                      {Cookies.get('AddAddressString') || "123"}
                                    </h4> </>)}
                                </>


                              );
                            }
                            else {
                              return (
                                <>

                                  <div class={style}>
                                    <h2 class="d-flex align-items-center justify-content-center" style={{ color: "#a0b3c6" }}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="52.498" height="52.387" viewBox={viewBox} style={{ marginRight: "3%" }}>
                                        <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                          <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                          <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                          <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                          <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                          <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                          <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                          <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                          <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                          <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                        </g>
                                      </svg>
                                      {currentactive} Evaluation
                                    </h2>

                                  </div>
                                  <div class="card custom-accordian view-custom-accordian mt-4" style={{ border: "0px !important" }}>

                                    <ViewComponent
                                      key={index.toString()}
                                      name={item}
                                      object={tabs[active]}
                                      index={index}
                                      useVals={true}
                                      setTabsImage={setTabsImage}

                                      active={currentactive}
                                      setObject2={(data) => {
                                        console.log("main", data);
                                        let t = tabs;
                                        tabs[currentactive][data.Phase] = tabs[
                                          currentactive
                                        ][data.Phase].map((item) =>
                                          item.ParameterId === data.ParameterId
                                            ? data
                                            : item
                                        );
                                        setTabs(t)
                                      }}

                                    />

                                  </div>



                                </>


                              );
                            }
                          }


                          if ((active != "Single Family" && item == "Building Cost Breakdown") || item == "Land Analysis" || item == "Financing") {

                            if (active == "Condo") {
                              if (item == "Financing") {
                                Footerstyle = Footerstyle + " marginTop14";
                              }
                              if (item == "Land Analysis") {
                                Footerstyle = Footerstyle + " marginTop37";
                              }
                              if (item == "Building Cost Breakdown") {
                                Footerstyle = Footerstyle + " display-none";
                              }
                            }
                            else {
                              if (item == "Land Analysis") {
                                if (active == "Apartment") {
                                  Footerstyle = Footerstyle + " marginTop45";
                                }
                                else {
                                  Footerstyle = Footerstyle + " marginTop44";
                                }

                              }
                              if (item == "Building Cost Breakdown") {
                                if (active == "Apartment") {
                                  Footerstyle = Footerstyle + " display-none";
                                }
                                else {
                                  Footerstyle = Footerstyle + " marginTop9";
                                }
                              }

                            }
                            if (item == "Financing") {
                              if (active == "Apartment" || active == "Single Family" || active == "Condo") {
                                Footerstyle = Footerstyle + " marginTop41";
                              }
                              else {
                                Footerstyle = Footerstyle + " marginTop14";
                              }
                            }
                            return (
                              <>

                                <div class={style}>
                                  <h2 class="d-flex align-items-center justify-content-center" style={{ color: "#a0b3c6" }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="52.498" height="52.387" viewBox={viewBox} style={{ marginRight: "3%" }}>
                                      <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                        <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                        <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                        <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                        <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                        <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                        <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                        <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                        <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                        <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                      </g>
                                    </svg>
                                    {currentactive} Evaluation
                                  </h2>

                                </div>
                                <div class="card custom-accordian view-custom-accordian mt-4" style={{ border: "0px !important" }}>

                                  <ViewComponent
                                    key={JSON.stringify(tabsImage) + index.toString()}
                                    name={item}
                                    object={tabs[active]}
                                    index={index}
                                    useVals={true}
                                    setTabsImage={setTabsImage}

                                    active={currentactive}
                                    setObject2={(data) => {
                                      console.log("main", data);
                                      let t = tabs;
                                      tabs[currentactive][data.Phase] = tabs[
                                        currentactive
                                      ][data.Phase].map((item) =>
                                        item.ParameterId === data.ParameterId
                                          ? data
                                          : item
                                      );
                                      setTabs(t)
                                    }}

                                  />

                                </div>


                                {!show && (<><nav class={Footerstyle} id="pdfTableaaaaa" style={{ position: "relative" }}>

                                  <div style={{ backgroundColor: "#2967b2", textAlign: "center" }}>
                                    <img src="../assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg" style={{ paddingBottom: "20px", marginTop: "4%", width: "60px" }}></img>
                                    <p style={{ color: "White", paddingBottom: "4%" }}>© {new Date().getFullYear()} LandBridge Technologies.  All rights reserved.</p>
                                  </div>
                                </nav>
                                  <br />
                                  <br /> <br />


                                  <h4 class="d-flex align-items-center justify-content-center" style={{ color: "#a0b3c6" }}>
                                    {Cookies.get('AddAddressString') || "123"}
                                  </h4>   </>)}
                              </>


                            );
                          }
                          else {
                            return (
                              <>

                                <div class={style}>
                                  <h2 class="d-flex align-items-center justify-content-center" style={{ color: "#a0b3c6" }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="52.498" height="52.387" viewBox={viewBox} style={{ marginRight: "3%" }}>
                                      <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                        <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                        <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                        <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                        <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                        <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                        <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                        <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                        <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                        <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                      </g>
                                    </svg>
                                    {currentactive} Evaluation
                                  </h2>

                                </div>
                                <div class="card custom-accordian view-custom-accordian mt-4" style={{ border: "0px !important" }}>

                                  <ViewComponent
                                    key={JSON.stringify(tabsImage) + index.toString()}
                                    name={item}
                                    object={tabs[active]}
                                    index={index}
                                    useVals={true}
                                    setTabsImage={setTabsImage}

                                    active={currentactive}
                                    setObject2={(data) => {
                                      console.log("main", data);
                                      let t = tabs;
                                      tabs[currentactive][data.Phase] = tabs[
                                        currentactive
                                      ][data.Phase].map((item) =>
                                        item.ParameterId === data.ParameterId
                                          ? data
                                          : item
                                      );
                                      setTabs(t)
                                    }}

                                  />

                                </div>

                              </>
                            );
                          }

                        })}



                      </div>


                    </form>
                  )}


                </div>
              }
            </div>
            {show && (<nav class="navbar-expand navbar-light topbar" style={{ marginTop: "4%" }}>

              <div class="Bottom1 img1 Landbrige_map1 " style={{ backgroundColor: "#2365B0" }}>
                <div class="bg_content">

                  <h4 class="" style={{ color: "white" }}>
                    <img src="../assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg" style={{ paddingBottom: "0%", marginRight: "1%" }}></img>       land analysis made simple
                    <button class="col-5 btn btn-primary  PrintButton" type="button" onClick={printDocument} style={{ marginLeft: "3%" }}>
                      Download
                    </button>
                    <button class="col-5 btn btn-primary  PrintButton" onClick={printDocument} type="button" style={{ marginLeft: "1%" }}>
                      Print
                    </button></h4>
                </div>
              </div>
            </nav>)}
            <div class={isdownload}>
              <p style={{ padding: "6%" }} class="footerMsg">
                DISCLAIMER: The financial estimates on this website, or otherwise from this website or people affiliated with this website, should not substitute your own due diligence. We strongly encourage and recommend that you conduct your own research and arrive at your own conclusions. Furthermore, while we try to keep our data up to date, the information we are provided is sometimes incomplete or not compatible with our systems, leading to misinformation on property listings and exaggerated estimates
                z
                <br /><br />
                <b>*Use of this calculator signifies your agreement to our Terms of Use and the terms posted below.</b><br />The calculators found on LandBridge are designed to be used for informational and educational purposes only, and when used alone, do not constitute investment advice. LandBridge recommends that you seek the advice of a real estate professional before making any type of investment. The results presented may not reflect the actual return of your own investments. LandBridge is not responsible for the consequences of any decisions or actions taken in reliance upon or as a result of the information provided by these tools. Furthermore, LandBridge is not responsible for any human or mechanical errors or omissions. LandBridge obtains property details from various third-party sources, and LandBridge is not responsible or liable for the accuracy, completeness, or suitability of the property details. You are responsible for confirming the property details are accurate, complete, and suitable for your use case.
                TownHome Evaluation
              </p>
            </div>
            <nav class="navbar-expand navbar-light topbar" id="pdfTableaaaaa" >

              <div style={{ backgroundColor: "#2967b2", textAlign: "center", width: "100%" }} class="img Landbrige_map">
                <img src="../assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg" style={{ paddingBottom: "20px", marginTop: "4%", width: "60px" }}></img>
                <p style={{ color: "White", paddingBottom: "4%", marginBottom: "0%" }}>© {new Date().getFullYear()} LandBridge Technologies.  All rights reserved.</p>
              </div>

            </nav>
          </div></div>
      </div>
    </>
  );
}
export default ViewProperty;
